import React, { ReactNode, PureComponent } from 'react';
import { Icon, Modal, Dropdown, Menu, message } from 'antd';
import { ClickParam } from 'antd/lib/menu';

import { IReportQueryProps, IReportConfigProps, IReportViewProps } from '@duoke/tools/umd/report';
import { convertCamel } from '@duoke/tools/umd/utils';
import { DokButton } from 'src/components';
import { createPrefixClassnames } from 'src/tools';
import { exportToExcel } from 'src/tools/xlsx';
import ImportModule from 'src/routes/down/importBtn';
import { ITableSource } from './index';
import styles from './index.less';

const dok = createPrefixClassnames(styles, 'table');
const defaultProps = {
  params: {},
};
const initialState = {
  exportSpin: false, // 导出按钮是否loading
};
interface IRecordProps {
  is_all: number;
  ids: string[];
}
export interface IBatchOperation {
  list: Array<{ key: string; name: string }>;
  onChange: (e: { selectedCount: number } | ClickParam, record: IRecordProps) => void;
}
interface IProps<T> {
  type: string;
  params: IReportQueryProps;
  selectedCount?: number; // 选中项
  source: ITableSource<T>; // 报表数据
  basicConfig: IReportConfigProps; // 侧边栏基础配置
  otherOperation?: ReactNode;
  selectedRecord: IRecordProps;
  batchOperation?: IBatchOperation; // 批量操作
  getId: (record: any, i: number) => string;
  onExport?: (value: IReportQueryProps) => ITableSource<T>; // 导出
}
type State = Readonly<typeof initialState>;

export default class TopOperation extends PureComponent<IProps<any>, State> {
  static defaultProps = defaultProps;
  readonly state = initialState;

  render() {
    const { onExport, otherOperation, batchOperation, type } = this.props;
    const { exportSpin } = this.state;

    return (
      <div className={dok('content-top-operation')}>
        {otherOperation}
        {onExport && (
          <>
            <ImportModule type={[`export_report_${type}`]} />
            <DokButton loading={exportSpin} onClick={this.handleExport1}>
              导出
            </DokButton>
          </>
        )}
        {batchOperation &&
          batchOperation.onChange &&
          batchOperation.list &&
          batchOperation.list.length > 0 && (
            <Dropdown
              overlay={
                <Menu onClick={this.handleMenuClick}>
                  {batchOperation.list.map((v) => (
                    <Menu.Item key={v.key} className={styles['more-menu']}>
                      {v.name}
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <DokButton>
                <>
                  批量 <Icon type="down" />
                </>
              </DokButton>
            </Dropdown>
          )}
      </div>
    );
  }
  /**
   * 导出 Excel
   *
   * 1. 提示并开启 loading
   * 2. 根据现有参数请求后端数据
   * * 1. 正选，直接拼接
   * * 2. 反选，分页请求并删选未选择
   * * 3. 未选，分页请求
   * 3. 拼接 Excel 并下载
   * 4. 关闭 loading
   * 5. 超过 1000 条提示报错
   */
  handleExport = async () => {
    const {
      getId,
      params,
      onExport,
      basicConfig,
      selectedCount,
      selectedRecord,
      source,
      source: { page },
    } = this.props;

    console.log(selectedCount, selectedRecord);
    if (!selectedCount && (!page || !page.total)) {
      Modal.error({
        title: '导出失败',
        content: '暂不支持全量导出数据，请选择需要导出的数据',
      });
    } else if ((selectedCount || page.total) > 1000) {
      Modal.error({
        title: '导出失败',
        content: '导出数据不能多于 1000 条',
      });
    } else if (onExport) {
      this.setState({ exportSpin: true });
      const viewMap = (basicConfig.views || []).reduce(
        (acc, v) => ((acc[v.value] = v), acc),
        {} as Record<string, IReportViewProps>
      );
      const data = [(params.views || []).map((v) => (viewMap[v.fieldKey] || {}).name)];
      // 正选，直接拼接
      if (selectedCount && !selectedRecord.is_all) {
        data.push(
          ...source.data
            .filter((v, i) => selectedRecord.ids.includes(getId(v, i)))
            .map((item) =>
              (params.views || []).map((v) => {
                const t = item[convertCamel(v.fieldKey)];
                return t && typeof t === 'object' ? t.name : t;
              })
            )
        );
        exportToExcel(data);
      } else {
        // 2.反选/未选，先分页请求
        const info = Modal.info({
          title: '数据导出中...',
          content: '由于数据过多，导出需要时间，请耐心等待不要进行其他操作。',
        });
        let startNo = 1;
        while ((startNo - 1) * 200 < page.total) {
          const list = await onExport({
            ...params,
            page: {
              startNo,
              size: 200,
            },
          });
          data.push(
            ...(list.data || [])
              .filter((v, i) => !selectedRecord.ids.includes(getId(v, i)))
              .map((item) =>
                (params.views || []).map((v) => {
                  const t = item[convertCamel(v.fieldKey)];
                  return t && typeof t === 'object' ? t.name : t;
                })
              )
          );
          startNo += 1;
        }
        exportToExcel(data);
        info.destroy();
      }
      this.setState({ exportSpin: false });
    }
  };
  // 异步导出
  handleExport1 = async () => {
    const { params, onExport } = this.props;

    if (onExport) {
      this.setState({ exportSpin: true });

      await onExport(params);

      this.setState({ exportSpin: false });
    }
  };
  handleMenuClick = (e: ClickParam) => {
    const { selectedCount, selectedRecord, batchOperation } = this.props;
    if (!selectedCount) {
      message.error('请先选择需要批量操作的商品！');
    } else {
      batchOperation &&
        batchOperation.onChange &&
        batchOperation.onChange({ ...e, selectedCount }, selectedRecord);
    }
  };
}
